import { useEffect, useState } from 'react'
import { enabledPromos, type PromoApp } from '../lib/promo'
import { openExternalUrl } from '../lib/openExternal'

const ROTATE_MS = 8000

export function PromoBanner() {
  const promos = enabledPromos()
  const [index, setIndex] = useState(0)
  const [paused, setPaused] = useState(false)

  useEffect(() => {
    if (promos.length < 2 || paused) return
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % promos.length)
    }, ROTATE_MS)
    return () => window.clearInterval(timer)
  }, [paused, promos.length])

  if (promos.length === 0) return null
  const promo: PromoApp = promos[index % promos.length]

  return (
    <aside
      className="overflow-hidden rounded-2xl border border-whiskey/35 bg-gradient-to-r from-whiskey/20 via-bar-raised to-bar-overlay"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <button
        type="button"
        className="flex w-full items-stretch gap-3 px-4 py-3 text-left"
        onClick={() => void openExternalUrl(promo.url)}
        aria-label={`${promo.cta}. ${promo.tagline}`}
      >
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <div className="flex items-center justify-between gap-2">
            <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-whiskey">
              Shame Logic ad
            </p>
            {promos.length > 1 ? (
              <span className="text-[10px] text-foam-faint">
                {index + 1}/{promos.length}
              </span>
            ) : null}
          </div>
          <p className="text-sm font-bold text-foam">{promo.name}</p>
          <p className="text-sm leading-snug text-foam-muted">{promo.tagline}</p>
          <p className="text-xs font-bold text-whiskey-light">{promo.cta} →</p>
        </div>
        {promo.iconSrc ? (
          <img
            src={promo.iconSrc}
            alt=""
            width={56}
            height={56}
            className="my-auto h-14 w-14 shrink-0 rounded-[14px] border border-white/10 shadow-md"
          />
        ) : null}
      </button>
    </aside>
  )
}
